<template>
  <div class="banner">
    <img v-if="isWechat" class="home-bg" src="@/assets/icon/home-bg.png" alt="">
    <video v-else autoplay muted loop preload="auto" id="myVideo" webkit-playsinline="" playsInline x5-playsinline t7-video-player-type="inline" x5-video-player-type="h5-page" x-webkit-airplay="allow" disablePictureInPicture>
      <source
        src="https://video.feifanbio-tech.com/video/%E9%A6%96%E9%A1%B5%E8%A7%86%E9%A2%91%E5%A4%84%E7%90%86%E7%89%88.mp4"
        type="video/mp4"
      />
    </video>
    <div class="content">
      <img class="txt-img" src="@/assets/icon/home2.png" alt="" />
      <a
        class="btn"
        href="https://www.feifanbio-tech.com/index.php/%e5%b9%b3%e5%8f%b0%e4%bb%8b%e7%bb%8d/"
        rel="noopener"
        target="_parent"
      >
        <span class="text">探索我们</span>
        <img class="btn-icon" src="@/assets/icon/home1.png" mode="" />
      </a>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { closeDialog } from "vant";
import { onMounted, onUnmounted, ref } from "vue";
const isWechat = ref(false)
onMounted(()=>{
 isWeChatMobileBrowser()
})
function isWeChatMobileBrowser() {
    const userAgent = navigator.userAgent.toLowerCase();
    const isMobile = /mobile/i.test(userAgent);
    const isWeChat = /micromessenger/i.test(userAgent);
    if (isMobile && isWeChat) {
        const weChatVersionMatch = userAgent.match(/micromessenger\/([\d.]+)/);
        if (weChatVersionMatch) {
            const weChatVersion = weChatVersionMatch[1];
            console.log(`当前微信版本号为: ${weChatVersion}`);
        }
        isWechat.value = true
        return true;
    }
    isWechat.value = false
    return false;
}
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;

  video,.home-bg {
    position: absolute;
    top: 0;
    left: 0;
    object-fit: cover;
    width: 100%;
    height: 100%;
    pointer-events: none;
  }
  @keyframes scaleAnimation {
    0% {
        transform: scale(1);
      }
    50% {
        transform: scale(1.05);
      }
    100% {
        transform: scale(1);
      }
  }
  .home-bg {
    animation: scaleAnimation 6s infinite;
  }
  .video::-webkit-media-controls {
    display: none !important;
  }
  .content {
    position: relative;
    z-index: 1;
    max-width: 1290px;
    margin: 0 auto;
    text-align: center;
  }
}

.txt-img {
  width: 85%;
}
.btn {
  color: #ffffff;
  display: flex;
  width: 140px;
  padding: 10px 0;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 2px;
  border: 1px solid #fff;
  background: rgba(255, 255, 255, 0.12);
  font-size: 16px;
  font-weight: 500;
  margin: 10px auto;
  text-decoration: unset;
}
.btn .btn-icon {
  width: 22px;
  height: 6.5px;
}

/* 当屏幕宽度小于或等于 600px 时 */
@media (max-width: 600px) {
  .btn {
    color: #ffffff;
    display: flex;
    width: 120px;
    padding: 5px 0;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 2px;
    border: 1px solid #fff;
    background: rgba(255, 255, 255, 0.12);
    font-size: 14px;
    font-weight: 500;
    margin: 5px auto;
    text-decoration: unset;
  }
}
</style>
